const collections = {
    videos: 'videos',
    events: 'events',
    musicians:  'musicians',
    photos: 'photos',
    texts: 'textContent',
    donors: 'donors',
    grants: 'grants',
    // csv: 'CSVs',
    csv: 'CSVs',
    subscribers: 'subscribers',
    images: 'images',
    campaigns: 'campaigns',
    tags: 'tags',
    lists: 'lists',
    logs: 'logs',
    tasks: 'tasks',
    users: 'users'
};

export default collections;
